/* template */
<template><div class="container"><div class="title">旅行时间</div><div class="options"><mpx-view v-for="(item, index) in (dateOptions.months)" :key="item.value" :class="({active:item.active})" @tap="onSelect('months', item)" class="option">{{item.label}}</mpx-view></div><div class="title">周几出发</div><div class="options"><mpx-view v-for="(item, index) in (dateOptions.weeks)" :key="item.value" :class="({active:item.active})" @tap="onSelect('weeks', item)" class="option">{{item.label}}</mpx-view></div><mpx-view @tap="onConfirm" class="footer-button">确定</mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3b2a36c7"}'>
.container
  height 479px
  background-color #fff
  font-family PingFang SC
  color #333
  padding 0 14px
  position relative
  .footer-button
    background #FF6400
    border-radius 10px
    display flex
    align-items center
    justify-content center
    color #fff
    font-weight 600
    font-size 16px
    height 50px
    position absolute
    bottom 34px
    width calc(100% - 28px)
  .title
   padding 24px 0 16px 0
   display flex
   align-items center
   font-weight 600
   font-size 16px
   line-height 1
   &:first-child
    padding-top 12px
  .options
    display flex
    align-items center
    justify-content space-between
    .option
      flex-grow 1
      background #F6F7F8
      margin-right 8px
      height 42px
      display flex
      align-items center
      justify-content center
      border-radius 8px
      font-weight 400
      font-size 14px
      box-sizing border-box
      border 1px solid #fff
      overflow hidden
      &:last-child
        margin-right 0
      &.active
        background #fff
        border-color #FF6400
        position relative
        &:after {
          content ''
          position absolute
          width 18px
          height 14px
          right -1px
          bottom -1px
          background-image url("https://dpubstatic.udache.com/static/dpubimg/sJ9KdDopDQpQoKQX0zqOD.png")
          background-size 100% 100%
}
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3b2a36c7"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./fuzzy-select-date.mpx.js?isComponent&outputPath=components%2Ffuzzy-select-date3b2a36c7%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./fuzzy-select-date.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Ffuzzy-select-date3b2a36c7%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3b2a36c7"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/fuzzy-select-date3b2a36c7/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
